import { Currency } from '@/core/currency/interfaces';

const LKR: Currency = {
    name: 'Sri Lankan Rupee',
    demonym: 'Sri Lankan',
    majorSingle: 'Rupee',
    majorPlural: 'Rupees',
    codeNumeric: '144',
    symbol: 'Rs.',
    symbolNative: 'රු or ரூ',
    minorSingle: 'Cent',
    minorPlural: 'Cents',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'LKR',
    delimiters: {
        thousands: ',',
        decimal: '.'
    }
};

export default LKR;
